import { API } from "@aws-amplify/api";

export const sendContacts = `query MyQuery($input: cidInput) {
    sendContacts(input: $input) {
      status
    }
    }`;



export async function SMSContacts(customerId:any): Promise<any> {
  try {
//return responseObject;
const response: any = await API.graphql({ query: sendContacts, variables: {input:{customerId:customerId} } });
console.log("SMS", response)
   return response
  } catch (error) {
    console.log("send Contacts", error);
  }
}